import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { Report } from '../../../../shared/model-typings';
import type { ReportV3Format } from '../../../components/reportsv3/types';

function fetchAttributionLink(projectLocator: string, format: ReportV3Format) {
  return get<Report>(
    `/api/revisions/${nuc(projectLocator)}/attribution/public`,
    false,
    { format },
  );
}

export const getAttributionLinkQueryKey = (
  projectLocator: string,
  format: ReportV3Format,
): QueryKey => ['reports', 'attributionLink', projectLocator, format];

/**
 * Hook to generate a public attribution link for a project.
 * Uses enabled: false so the query only runs when refetch() is called.
 *
 * @param projectLocator The project locator string.
 * @param format The report format.
 */
export function useGenerateAttributionLink(projectLocator: string, format: ReportV3Format) {
  return useQuery<Report>({
    queryKey: getAttributionLinkQueryKey(projectLocator, format),
    queryFn: () => fetchAttributionLink(projectLocator, format),
    enabled: false,
    staleTime: 1000 * 60 * 5, // 5 minutes, because the link should still be valid for a while.
  });
}
